import { render } from "./ModalHeader.vue?vue&type=template&id=f1c26c90"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"

import "./ModalHeader.vue?vue&type=style&index=0&id=f1c26c90&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__